<template>
  <div>
    <page-header title="Incident And Request" breadcrumb="Dashboard > Booking & Shipments > Incident And Request" />
    <div class="flex justify-between mt-8 mb-0">
      <div class="flex">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'incident' }"
          @click="currentTab = 'incident'"
        >
          <p>Incident</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'request' }"
          @click="currentTab = 'request'"
        >
          <p>Request</p>
        </div>
        
      </div>
      <div class="flex" v-if="currentTab != 'incident'">
        <!-- <div class="mr-2 filter flex items-center">
          <img src="@/assets/images/icons/filter.svg" class="cursor-pointer" alt="filter icon" />
        </div>  -->
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="searchQuery"
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>
    </div>
    <hr />
    <keep-alive>
      <component :is="currentTab" :searchQuery="searchQuery"></component>
    </keep-alive>
  </div>
</template> 

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Request from "@/components/3pl/IncidentAndRequest/Tabs/Request";
import Incident from "@/components/3pl/IncidentAndRequest/Tabs/Incident";

export default {
  components: {
    Request,
    Incident,
    PageHeader
  },
  data() {
    return {
      currentTab: "incident",
      searchQuery: '',
      count: {},
    };
  },
  watch: {
    currentTab(val) {
      this.$store.dispatch("setCurrentUsersAndGroupTab", val);
    }
  },
  mounted() {
    const currentTab = this.$store.getters.currentUserAndGroupsTab;
    if (currentTab) {
      this.currentTab = currentTab;
    }
  },
  methods: {
    showDeleteModal(payload) {
      this.itemToDelete = payload[0];
      this.selectedId = payload[1];
      this.isDeleteModal = true;
    },
    async deleteUser() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteUser(this.selectedId);
        this.onDeleteUser(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteGroup() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteGroup(this.selectedId);
        this.onDeleteGroup(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    onDeleteUser(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      this.$refs.usersDataTable.getAllUsers();
      this.generateToast("User successfully deleted!", "success");
    },
    onDeleteGroup(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      // this.fetchGroups = true;
      this.$refs.groupsDataTable.getAllGroups();
      this.generateToast("Group successfully deleted!", "success");
    },
    deleteItem() {
      if (this.itemToDelete == "User") {
        this.deleteUser();
      } else if (this.itemToDelete == "Group") {
        this.deleteGroup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #FCC210;
    font-weight: bold;
  }
}
</style>